import Dispatcher from '../../../flux/dispatcher/dispatcher';
var EventEmitter = require('events').EventEmitter;
var Constants = require('../constant/SignupConstant');
var assign = require('object-assign');
var RESPONSE_CHANGE_EVENT = 'globalResponse';

var confirmationSignUp = {}
function parseResponse(resp) {
    confirmationSignUp = 200;
}

function parseError(resp) {
    // console.log(resp)
    confirmationSignUp = resp;
}

var SignupStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getSignInResponse: function () {
        return confirmationSignUp
    }
});

Dispatcher.register(function (action) {
    switch (action.actionType) {
        case Constants.SIGNUP_RESPONSE_RECEIVED:
            var resp = action.data;
            parseResponse(resp)
            // console.log("SignUpStore......", resp)
            SignupStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);
            break;

        case Constants.SIGNUP_ERROR:
            var res = action.data;
            parseError(res)
            // console.log("SignUpStore error......", res)
            SignupStore.emitChangeEvent(RESPONSE_CHANGE_EVENT)
            break;
        default:
    }
});

export default SignupStore;